import React from 'react';
import PropTypes from 'prop-types';

const GreenCheck = ({ className }) => (
  <svg className={className} width="16px" height="12px" viewBox="0 0 16 12" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="Save-Sandbox" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Post-Save-Estimate" transform="translate(-37.000000, -951.000000)" fill="#00AE4D">
        <g id="Group-4" transform="translate(19.000000, 512.000000)">
          <g id="Group-3" transform="translate(18.000000, 434.000000)">
            <polygon id="check" points="5.20507812 15.6816406 0.494140625 11.0234375 2.375 9.125 6.1015625 12.8691406 13.6074219 5.38085938 15.5058594 7.24414062 6.11914062 16.6308594" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

GreenCheck.propTypes = {
  className: PropTypes.string,
};
GreenCheck.defaultProps = {
  className: '',
};

export default GreenCheck;
